import { render, staticRenderFns } from "./InputFromKomship.vue?vue&type=template&id=609c8f0a&scoped=true&"
import script from "./InputFromKomship.vue?vue&type=script&lang=js&"
export * from "./InputFromKomship.vue?vue&type=script&lang=js&"
import style0 from "./InputFromKomship.vue?vue&type=style&index=0&id=609c8f0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609c8f0a",
  null
  
)

export default component.exports